import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=47b20c7e&scoped=true"
import script from "./PaymentMethods.vue?vue&type=script&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethods.vue?vue&type=style&index=0&id=47b20c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b20c7e",
  null
  
)

export default component.exports